module.exports = __webpack_public_path__ + "img/電気回路_2_9_4.7c726e89.png";